import {gql} from '@apollo/client';
import {useLazyQuery} from '@apollo/client/react';

const GET_ALL_USERS = gql`
    query AllUsers {
        allUsers {
            uuid
            trigram
            firstname
            lastname
            leaveDate
        }
    }
`;

const useAllUsers = () => {

    const [getAllUsers, {loading, error, data, refetch}] = useLazyQuery(GET_ALL_USERS, {
        fetchPolicy: 'network-only'
    });

    return {
        getAllUsers,
        loading,
        error,
        allUsers: data?.allUsers,
        refetch
    };
};

export default useAllUsers;
